import { render, staticRenderFns } from "./notification-center.vue?vue&type=template&id=4f5952a0&scoped=true"
import script from "./notification-center.vue?vue&type=script&lang=js"
export * from "./notification-center.vue?vue&type=script&lang=js"
import style0 from "./notification-center.vue?vue&type=style&index=0&id=4f5952a0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5952a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f5952a0')) {
      api.createRecord('4f5952a0', component.options)
    } else {
      api.reload('4f5952a0', component.options)
    }
    module.hot.accept("./notification-center.vue?vue&type=template&id=4f5952a0&scoped=true", function () {
      api.rerender('4f5952a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/notification-center.vue"
export default component.exports